import { SortItem, sortTypes, sortDirection } from '../ss-api/responses/member.dashboard.license.response';

export interface IEmailLogItemBasic {
    ID: number;
    FromEmail: string;
    ToEmail: string;
    DateTime: Date;
    Result: boolean;
    ResultMessage: boolean;
    MemberID: number;
    AdminID: number;
    AdminName: string;
    Subject: string;
    Body: string;
}

export class EmailLogItemBasic implements IEmailLogItemBasic {
    ID: number;
    FromEmail: string;
    ToEmail: string;
    DateTime: Date;
    Result: boolean;
    ResultMessage: boolean;
    MemberID: number;
    AdminID: number;
    AdminName: string;
    Subject: string;
    Body: string;
}

export class EmailLogItemBasicArray extends Array<EmailLogItemBasic> {

    public LastSort = new SortItem;

    constructor(...items: EmailLogItemBasic[]) {
        super(...items);
        Object.setPrototypeOf(this, EmailLogItemBasicArray.prototype);
    }

    public static checkVariables(checkThis: EmailLogItemBasicArray) {
        if ( checkThis.LastSort == undefined ) {
            checkThis.LastSort = new SortItem;
            checkThis.LastSort.SortType = sortTypes.ID;
            checkThis.LastSort.SortDirection = sortDirection.Unsorted;
        }
    }


    public static sortByDate( sortThis: EmailLogItemBasicArray, direction: sortDirection = sortDirection.NotSpecified ): EmailLogItemBasicArray {
        this.checkVariables(sortThis);
        if ( (sortThis.LastSort.SortType == sortTypes.NoteCreated && direction == sortDirection.NotSpecified && sortThis.LastSort.SortDirection == sortDirection.Ascending) || direction == sortDirection.Descending ) {
            sortThis.sort( (a, b) => {
                if (b.DateTime < a.DateTime) return -1;
                else if (b.DateTime > a.DateTime) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Descending;
        } else {
            sortThis.sort( (a, b) => {
                if (a.DateTime < b.DateTime) return -1;
                else if (a.DateTime > b.DateTime) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Ascending;
        }
        sortThis.LastSort.SortType = sortTypes.NoteCreated;
        return sortThis;
    }

}
